import '../styles/CustomButton.css';

export function CustomButton({
  children,
  onClick,
  disabled = false,
  className = '',
  type = 'button'
}) {
  return (
    <button onClick={onClick} disabled={disabled} className={`${className}`} type={type}>
      {children}
    </button>
  );
}
